import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';

import { environment } from 'environments/environment';
import { map, Observable } from 'rxjs';

import { EndpointPolicyResult, Objeto } from '../models/objeto.model';
import { Wrapper } from '../models/wrapper.model';
import KeyValuePair from '../models/key-value-pair.model';

@Injectable()
export class ObjetoService {
    private http = inject(HttpClient);

    securityApi = `${environment.api}/svc-security/api`;   
    
    children(idenObje: string, type: string, idenObjeCheckLink?: string, page = 1, size = 9999): Observable<Wrapper<EndpointPolicyResult>> {
        idenObjeCheckLink = (idenObjeCheckLink || '');
        const queryStr = `${this.securityApi}/objeto/children?idenObjeParent=${idenObje}&types=${type}&skip=${(page - 1) * size}&take=${size}&idenObjeCheckLink=${idenObjeCheckLink}`;
        return this.http.get<Wrapper<EndpointPolicyResult>>(queryStr);
    }

    list(idenServ: string, type: string, page = 0, size = 10): Observable<HttpResponse<Wrapper<{ results: Objeto[] }>>> {
        return this.http.get<Wrapper<{ results: Objeto[] }>>(
            `${this.securityApi}/objeto/by-types?idenServ=${idenServ}&types=${type}&skip=${(page - 1) * size}&take=${size}`, { observe: 'response' }
        );
    }

    menu(idenServ: string): Observable<Wrapper<Objeto[]>> {
        // const test = 'https://services-hom.oab.org.br/cs-security/api'
        // return this.http.get<Wrapper<Objeto[]>>(`${test}/objeto/menu?idenServ=${idenServ}`);
        return this.http.get<Wrapper<Objeto[]>>(`${this.securityApi}/objeto/menu?idenServ=${idenServ}`);
    }

    menuUser(idenServ: string): Observable<Wrapper<Objeto[]>> {
        // const test = 'https://services-hom.oab.org.br/cs-security/api'
        //  return this.http.get<Wrapper<Objeto[]>>(`${test}/objeto/menu-usr-login?idenServ=${idenServ}`);
        return this.http.get<Wrapper<Objeto[]>>(`${this.securityApi}/objeto/menu-usr-login?idenServ=${idenServ}`);
    }
    link(idObjeto: string, tipoObjeto: string[], filhos: string[], removerFilhos = false, removeExistingParents = false) {        
        return this.http.put<Wrapper<Objeto>>(`${this.securityApi}/objeto/link/${idObjeto}`, {
            childList: filhos,
            removeExistingParents: removeExistingParents,
            removeExistingChildren: removerFilhos,
            removeChildrenIdenTipoObje: tipoObjeto
        });
    }

    save(objeto: Objeto, listIdenObjeParent: string[] = null): Observable<Objeto> {        
        delete objeto.idenObje;           

        let params = '';        
        if (listIdenObjeParent != null && listIdenObjeParent.length > 0) {
            params = '?listIdenObjeParent=' + listIdenObjeParent.join('&listIdenObjeParent=');      
        }      
                
        return this.http.post<Objeto>(`${this.securityApi}/objeto${params}`, objeto);
    }

    update(objeto: Objeto, listIdenObjeParent: string[] = null): Observable<Objeto> {                 
        let params = '';
        if (listIdenObjeParent != null && listIdenObjeParent.length > 0) {
            params = '?listIdenObjeParent=' + listIdenObjeParent.join('&listIdenObjeParent=');
        } 

        return this.http.put<Objeto>(`${this.securityApi}/objeto/${objeto.idenObje}${params}`, objeto);
    }

    updateMenu(objeto: Objeto, idenObjeParent?: string): Observable<Objeto> {        
        const queryString = idenObjeParent ? `?idenObjeParent=${idenObjeParent}` : '';
        return this.http.put<Objeto>(`${this.securityApi}/objeto/menu/${objeto.idenObje}${queryString}`, objeto);
    }    

    get(objetoId: string): Observable<Wrapper<Objeto>> {
        return this.http.get<Wrapper<Objeto>>(`${this.securityApi}/objeto/${objetoId}`);
    }

    groupByType(idenObje: string, tipoObj: string): Observable<Wrapper<KeyValuePair[]>> {
        return this.http.get<Wrapper<KeyValuePair[]>>(`${this.securityApi}/objeto/grupo/by-type?idenObje=${idenObje}&tipoObj=${tipoObj}`);
    }

    listByTypeAny(idenServ: string, tipoObje: string, tipoObjeChildren: string, idenObjeCheckLink: string, children= true): Observable<Wrapper<EndpointPolicyResult>>{
        const queryStr = `${this.securityApi}/objeto/by-type-any?idenServ=${idenServ}&tipoObje=${tipoObje}&tipoObjeChildren=${tipoObjeChildren}&idenObjeCheckLink=${idenObjeCheckLink}&children=${children}`;
        return this.http.get<Wrapper<EndpointPolicyResult>>(queryStr);
    }

    remove(objetoId: string): Observable<Objeto> {
        return this.http.delete<Objeto>(`${this.securityApi}/objeto/${objetoId}`);
    }

    unlink(parentId: string, filhos: string[]) {
        return this.http.put(`${this.securityApi}/objeto/unlink/${parentId}`, { childList: filhos });
    }

}
